<template>
    <section :class="shit$(`w:100%; relative;`)">
      <el-table
        ref="tableView"
        :row-style="({ row }) => isOpen(row) ? { backgroundColor: 'rgba(0, 0, 0, 0.2)!important' } : row[row.type$] === currentClickRowId && rowStyleStr || {}"
        :data="filterData"
        style="width:100%; height:calc(100% - 72px);"
        @selection-change="handleSelectionChange"
        class="manager-table"
        >
         <el-table-column
          type="selection"
          width="55">
        </el-table-column>
        <el-table-column
          :label="attrStrTable1"
          min-width="250"
          :render-header="handleRenderHeader">
          <template slot-scope="scope">
            <div :class="shit$(`dis:i-b;w:100%;`)" @dblclick="rowDbClickCb(scope.row)" @click="rowClickCb(scope.row, $isMobile)" @touchstart.stop="rowClickCb(scope.row, false)">
              <svg-icon  height="50" width="50" :href="scope.row.projectId ? '#t-code-file-management-project' : '#t-code-file-management-folder'"></svg-icon>
              <span :class="shit$(`ml:15px;`)">{{ scope.row.name$ && scope.row.name$.length > 13 ? scope.row.name$.substring(0, 9) + '...' + scope.row.name$.substr(-5) : scope.row.name$ }}</span>
              <!-- <span :class="shit$(`c:${typeof scope.row.name$ !== 'string' && caonima(scope.row)};`)">{{ scope.row.name$ }}</span> -->
            </div>
          </template>
        </el-table-column>
        <el-table-column
          :label="attrStrTable2"
          min-width="150"
          :render-header="handleRenderHeader">
          <template slot-scope="scope">
            <span :class="shit$(`c:#696969; letter-s:0.86px;`)" v-if="isOpen(scope.row)">{{ scope.row.openUserName }} {{this.$t( "code-lab/component/file-management/table.vue_0" ) }}...</span>
            <div v-else :class="shit$(`dis:f; flex-d:c;`)">
              <span>{{ dateFormatter(scope.row.updatedAt) }}</span>
              <!-- <span v-if="isOpen(scope.row)" :class="shit$(`c:#696969;`)">{{this.$t( "code-lab/component/file-management/table.vue_1" ) }} {{ scope.row.openUserName }} {{this.$t( "code-lab/component/file-management/table.vue_2" ) }}</!-->
            </div>
          </template>
        </el-table-column>
        <template >
          <el-table-column
            prop="creator"
            :label="attrStrTable3"
            :render-header="handleRenderHeader"
            :formatter="creatorFormatter">
          </el-table-column>
        </template>
        <el-table-column
          v-if="currentVersion === 'teacher'"
          prop="groups"
          :label="attrStrTable4"
          :render-header="handleRenderHeader"
          :formatter="groupsFormatter">
        </el-table-column>
        <!-- <el-table-column :label="attrStrTable5"
          :render-header="handleRenderHeader"
        >
          <template slot-scope="scope">
            <div v-if="isOpen(scope.row)" :class="shit$(`w:25px; dis:f; justify-c:sb;`)">
                <span :class="shit$(`w:4px; h:4px; radius:50%; bgc:#a8a8ac;`)" v-for="(item, index) in 3" :key="index"></span>
            </div>
            <el-dropdown v-else trigger="click" @visible-change="a => !a ? (toolClickId = a) : (toolClickId = scope.row[scope.row.type$])">
                <div @click.stop="() => scope.row.type$ === '_id' ? idTableToolData(scope.row) : projectTableToolData(scope.row)" :class="shit$(`cursor:p; w:25px; h:20px; dis:f; justify-c:sb; align-i:c;`)">
                  <span :class="[shit$(`w:4px; h:4px; radius:50%; bgc:#a8a8ac;`), toolClickId && toolClickId === scope.row[scope.row.type$] && shit$(`bgc:#0ed3ff;`)]" v-for="(item, index) in 3" :key="index"></span>
                </div>
                <el-dropdown-menu slot="dropdown" :class="shit$(`ml:5px;`)">
                  <template v-if="scope.row.type$ === 'projectId' && projectTableToolDataArr.length">
                      <template v-for="(o, i) in projectTableToolDataArr" >
                        <el-dropdown-item :key="o + i">
                          <template v-if="i + 1 === projectTableToolDataArr.length">
                            <p :class="[shit$(`h:.5px; bgc:#a8a8ac; my:5px;`)]" ></p>
                          </template>
                          <div @click="$emit('table-tool-handle', { item: o, row: scope.row })" :class="[shit$(`font:12px; active:c:#0ed3ff; letter-s:0.69px; h:25px; lh:25px; hover:bgc:#444; text-a:c; c:#c8c8c8;`)]" >{{ o.label }}</div>
                        </el-dropdown-item>
                      </template>
                  </template>
                  <template v-if="scope.row.type$ === '_id' && idTableToolDataArr.length">
                      <template v-for="(o, i) in idTableToolDataArr" >
                        <el-dropdown-item :key="o + i">
                            <template v-if="i + 1 === idTableToolDataArr.length">
                              <p :class="[shit$(`h:.5px; bgc:#a8a8ac; my:5px;`)]" ></p>
                            </template>
                            <div @click="$emit('table-tool-handle', { item: o, row: scope.row })" :class="[shit$(`font:12px; active:c:#0ed3ff; letter-s:0.69px; h:25px; lh:25px; hover:bgc:#444; text-a:c; c:#c8c8c8;`)]" >{{ o.label }}</div>
                        </el-dropdown-item>
                      </template>
                  </template>
                </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column> -->
      </el-table>
      <div v-if="!filterData.length" :class="shit$(`absolute; top:205px; w:100%; text-a:c;`)">
        <svg-icon href="#code-empty-folder-icon-fileManage" height="88" width="88"></svg-icon>
        <section :class="shit$(`mt:20px; font:18px; lh:1.6; c:#696969; letter-s:1.29px;`)">
          <p>{{this.$t( "code-lab/component/file-management/table.vue_3" ) }}，{{this.$t( "code-lab/component/file-management/table.vue_4" ) }}</p>
          <p>{{this.$t( "code-lab/component/file-management/table.vue_5" ) }} Code Lab～</p>
        </section>
      </div>
      <project-edit-bar style="margin-left: -18px;width: calc(100% + 18px)"
      :select-count="selectionInfo.selectionCount"
      :options="editBarData"
      @handleEdit="handleEdit"
      ></project-edit-bar>
    </section>
</template>

<script>
import { mapState } from "vuex";
import ToolMix from '@/code-lab/component/file-management/mixins/tool-mix.js'
import { store as tableToolStore } from '@/code-lab/component/file-management/observable/tableToolOber.js'
import { store as menueStore } from '@/code-lab/component/layout/control-menue/observable.js'
import mixFileRequestManage from '@/code-lab/component/file-management/mixins/mix-file-request-manage.js'
import indexMixStore from '@/code-lab/component/mixins/indexMixStore.js'
import projectEditBar from "@/code-lab/component/file-management/project-edit-bar.vue"
export default {
  mixins: [ ToolMix, mixFileRequestManage, indexMixStore ],
  props: {
    data: Array,
    header: Array,
    scrollLoadState: Number
  },
  components: {
    projectEditBar
  },
  data () {
    return {
      attrStrTable1: this.$t("code-lab/component/file-management/table.vue_6"),
      attrStrTable2: this.$t("code-lab/component/file-management/table.vue_7"),
      attrStrTable3: this.$t("code-lab/component/file-management/table.vue_8"),
      attrStrTable4: this.$t("code-lab/component/file-management/table.vue_9"),
      attrStrTable5: this.$t("code-lab/component/file-management/table.vue_10"),
      sort: "",
      creator: this.$t( "code-lab/component/file-management/table.vue_11" ),
      rowStyleStr: "",
      judgeTimer: null,
      sortTimerClosure: null,
      sortPathClosure: null,
      sortPathMp: false,
      currentClickRowId: "",
      idTableToolDataArr: [],
      projectTableToolDataArr: [],
      toolClickId: '',
      sortTimeClick: '',
      sortPathClick: '',
      selections: [],//被勾選的清單
      selectionInfo: {
        selectionCount: 0,
        targetType: 0
      }
    }
  },
  computed: {
    ...mapState(["currentVersion", 'groupTeamArr', 'userInfo']),
    filterData(){
      if(!this.data){
        return [];
      }
      return this.data.filter(item => !item.missionId)
    },
    editBarData(){
      const {
        selectionCount,
        targetType,
      } = this.selectionInfo;
      let folderType = menueStore.current;
      if(selectionCount === 0 || targetType === null || !["my", "shared"].includes(folderType)){
        return [];
      }
      let table;
       if (this.currentVersion === 'teacher') {
          table = tableToolStore[this.currentVersion][folderType]
        } else {
          table = tableToolStore[this.currentVersion]
        }
        return table[targetType];
    }
  },
  watch: {
    sort(sort) {
      console.log("sort:", sort)
      const params = this.header.slice(-1)[0]
      params.query.sort = sort
      typeof sort === "string" && this.$emit("handleHeaderDataProxy", params)
    },
    filterData () {
      // this.loadMore()
      this.$nextTick(() => {
        this.loadMore()
      })
    },
    scrollLoadState (scrollLoadState) {
      console.log(scrollLoadState, 'scrollLoadState')
    }
  },
  methods: {
    load (event) {
      const target = event.target
      if (target.scrollHeight - target.scrollTop - target.clientHeight  <= 10 ) {
        this.$emit('proxyloadScroll')
      }
    },
    loadMore () {
      const elemount = this.$refs.tableView.$el.querySelector('.el-table__body-wrapper > .el-table__body')
      elemount.removeEventListener('scroll', this.load, false)
      elemount.addEventListener('scroll', this.load, false)
    },
    idTableToolData () {
      let table = []
      let folderType = menueStore.current
      if (this.currentVersion === 'teacher') {
        table = tableToolStore[this.currentVersion][folderType]
      } else {
        table = tableToolStore[this.currentVersion]
      }
      this.idTableToolDataArr = table ? table.idTableTool : [];
    },
    projectTableToolData () {
      let table = []
      let folderType = menueStore.current
      if (this.currentVersion === 'teacher') {
        table = tableToolStore[this.currentVersion][folderType]
      } else {
        table = tableToolStore[this.currentVersion]
      }
      this.projectTableToolDataArr = table ? table.projectTableTool : [];
    },
    isOpen (data) {
      if(data.userId === this.userInfo.userId || data.userId === this.userInfo.studentId){
        return false;
      }
      return data.isOpen === true  && this.currentVersion !== 'family'
    },
    limitEvent({ fn, params }, timer) {
      return setTimeout(() => fn(params), timer);
    },
    clearSortState(sort = false) {
      Object.assign(this, { sort, sortPathMp: false })
    },
    dateFormatter(date) {
      return this.util$.getFormateDate$("yyyy-MM-dd hh:mm:ss", new Date(date))
    },
    creatorFormatter(row) {
      return row.creator ? row.creator : this.creator;
    },
    formatStringSubstrT (str, { s, e }, tag = '...') {
        if (typeof str !== 'string') return ''
        return str.substring(s, e) + tag
    },
    groupsFormatter(row) {
      const fn1 = this.formatStringSubstrT
      const arr = this.groupsNameT(row).split(',')
      const fn = (data, end = 5) => data.reduce((a, b) => [...a, ...[ b.length > end ? fn1(b, { s: 0, e: end }, '..') : b ]], [])
      const res = arr.length >= 3
      ? [...fn(arr.slice(0, 2)), ...[fn1(arr[2], { s: 0, e: 1 }, '...')]]
      : arr.length > 1 ? fn(arr, 6) : fn(arr, 15)
      return res.join(',')
    },
    
    handleSortValue(sort) {
      if (!this.sort) return (this.sort = sort)
      const mp = {
        "-dateTime": "time",
        dateTime: "time",
        path: "path",
        "-path": "path"
      };
      let sk = mp[sort]
      const fn = () => {
        const arr = this.sort.split(",");
        const index = arr.findIndex(key => mp[key] === sk);
        const item = arr.find(item => mp[item] === sk);
        
        item === sort ? arr.splice(index, 1) : arr.splice(index, 1, sort);
        return (this.sort = arr.join(","));
      };
      fn();
    },
    pathSortHandle() {
      const judge = (this.sortPathMp = !this.sortPathMp)
      const mp = { true: { sort: "dateTime" }, false: { sort: "-dateTime" } }
      const o = mp[judge]
      this.handleSortValue(o.sort)
    },
    handleRenderHeader(h, { $index, column }) {
      if ($index === 0) {
        return h("section", { class: this.shit$(`dis:f; align-i:c;`) }, [
          h("span", column.label),
          h(
            "el-dropdown",
            { props: { trigger: "click" }, class: this.shit$(`h:16px; lh:16px!; cursor:p;`), on: {
                'visible-change': c => this.sortPathClick = c
              } },
            [
              h("i", {
                class: `el-icon-caret-bottom ${this.shit$(
                  `font:16px; otl:n; ${ this.sortPathClick ? 'c:#0ed3ff' : 'c:#a8a8ac' };`
                )}`
              }),
              h(
                "el-dropdown-menu",
                { class: this.shit$(`w:87px; miw:auto; py:5px; ml:8px;`), slot: "dropdown", },
                [
                  [
                    { label: this.$t( "code-lab/component/file-management/table.vue_12" ), sort: "-path" },
                    { label: this.$t( "code-lab/component/file-management/table.vue_13" ), sort: "path" }
                  ].map((o) =>
                    h(
                      "el-dropdown-item", [
                        h('div', {
                          class: [
                            this.sort === o.sort && this.shit$(`c:#0ed3ff!;`),
                            this.shit$(
                              `hover:bgc:#444; h:25px; lh:25px; text-a:c; c:#c8c8c8;`
                            )
                          ],
                          on: {
                            click: e => {
                              this.l$('click', e)
                              this.sortPathMp = false
                              clearTimeout(this.sortPathClosure)
                              this.sortPathClosure = this.limitEvent(
                                { fn: this.handleSortValue, params: o.sort },
                                400
                              )
                            }
                          }
                        },
                        o.label)
                      ]
                    )
                  )
                ]
              )
            ]
          )
        ]);
      } else if ($index === 1) {
        return h("section", { class: this.shit$(`relative; right:5px;`) }, [
          h("span", column.label),
          h(
            "span",
            {
              class: this.shit$(`ml:4px; cursor:p;`),
              on: {
                click: () => {
                  clearTimeout(this.sortTimerClosure);
                  this.sortTimerClosure = this.limitEvent(
                    { fn: this.pathSortHandle },
                    500
                  );
                },
                mousedown: () => {
                  this.sortTimeClick = true
                },
                mouseup: () => this.sortTimeClick = false
              }
            },
            [
              h("svg-icon", {
                class: this.shit$(`w:18px; h:18px; `),
                props: {
                  href: this.sortTimeClick ?  (() => {
                    return this.sortPathMp
                    ? "#code-lab-sort-datetime-press-icon"
                    : "#code-lab-sort-datetimeb-press-icon"
                  })() : (() => {
                    return this.sortPathMp
                    ? "#t-cod-table-ascending"
                    : "#t-cod-table-descending"
                  })()
                }
              })
            ]
          )
        ]);
      } else {
        return h("span", { class: this.shit$(`relative; right:8px;`) }, column.label)
      }
    },
    rowClickCb(row, forceDbl) {
      if(forceDbl){
        this.rowDbClickCb(row);
      } else {
        if (this.isOpen(row)) return
        window.clearTimeout(this.judgeTimer);
        this.judgeTimer = window.setTimeout(() => {
          Object.assign(this, {
            currentClickRowId: row[row.type$],
            rowStyleStr: { backgroundColor: 'rgba(255, 255, 255, 0.2)!important', color: '#fff' }
          });
          
          this.$emit("getCurrentClickTableRowId", row);
        }, 500);
      }
    },
    rowDbClickCb(row) {
      if (this.isOpen(row)) return;
      
      if (!row.type$) return
      window.clearTimeout(this.judgeTimer);
      row.type$ === "_id"
        ? this.$emit("getCurrentDbClickTableRowId", row)
        : (() => {
            const { projectId } = row
            this.b$.send(
              "tool",
              { cmd: "get_project", data: { projectId } },
              response => {
                let { script, name, materials } = response.data;
                
                try {
                  script = script || ''
                  const scriptXml = window.nuwa.utils.base64.decode(script)
                  
                  
                  this.$store.commit('isCloudProject', true)
                  this.$store.commit("UPDATE_PROJECT_DATA", {
                    name,
                    projectId,
                    materials,
                    script: scriptXml,
                  })
                  setTimeout(() => {
                    this.handleScriptToWorkSpace(scriptXml);
                    setTimeout(() => {
                      this.$store.commit("SELECTEDMENUERIGHT", null)
                      
                      this.$store.commit("UPDATE_IS_SAVED", true);
                    }, 200);
                  }, 0);
                } catch (e) {
                  console.error([`excute window.nuwa.utils.base64.decode error!`, e]);
                }
              })
          })()
    },
    handleSelectionChange(value){
      console.log("handle selection change:", value);
      this.selections = value;
      this.selectionInfo = {
        selectionCount: value.length,
        targetType: this.getSelectionTargetType(value)
      }
    },
    getSelectionTargetType(selections){
      if(selections.every(item => item.type$ === "_id")){
        return "idTableTool"
      }
      if(selections.every(item => item.type$ === "projectId")){
        return "projectTableTool"
      }
      return null;
    },
    handleEdit(item){
      if(this.selectionInfo.selectionCount === 0){
        return;
      }
      this.$emit("tableToolhandle", {item, rows: this.selections})
    },
    clearSelection(){
      this.$refs.tableView && this.$refs.tableView.clearSelection();
    }
  },
};
</script>

<style lang="scss">
.el-tooltip__popper[x-placement^="right"] .popper__arrow {
  border-right-color: #1ab394;
}
.el-tooltip__popper[x-placement^="right"] .popper__arrow:after {
  border-right-color: #1ab394;
}
.el-tooltip__popper[x-placement^="bottom"] .popper__arrow {
  border-bottom-color: #a8a8ac;
}
.el-tooltip__popper[x-placement^="bottom"] .popper__arrow:after {
  border-bottom-color: #272727;
}
.el-table::before {
  height: 0px !important;
}
.el-dropdown-menu {
  border: 1px solid #a8a8ac;
  background-color: #272727;
  // width: 130px;
  min-width: 130px;
}
.el-dropdown-menu__item:not(.is-disabled):hover {
  background-color: #272727!important;
  color: #0ed3ff!important;
}
.el-dropdown-menu__item:focus {
  background-color: #272727!important;
  color: #0ed3ff;
}
.el-dropdown-menu__item {
  padding: 0px!important;
}
.el-popper[x-placement^=top] .popper__arrow {
    border-top-color: #a8a8ac;
    border-bottom-color: #a8a8ac;
    
}
.el-popper[x-placement^=bottom] .popper__arrow {
    border-bottom-color: #a8a8ac;
}
.manager-table{
  .el-checkbox__inner{
    background-color: transparent;
    border-color: #a8a8ac;
  }
}
</style>
